import { render, staticRenderFns } from "./ModalAddPotentialCustomer.vue?vue&type=template&id=1ed110a4&scoped=true&"
import script from "./ModalAddPotentialCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalAddPotentialCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPotentialCustomer.vue?vue&type=style&index=0&id=1ed110a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed110a4",
  null
  
)

export default component.exports